var map = {
	"./ar.json": 638,
	"./en.json": 639,
	"./localise_stf/ar.json": 287,
	"./localise_stf/en.json": 288,
	"./menu_ar.json": 289,
	"./menu_en.json": 290,
	"./menu_kw_ar.json": 215,
	"./menu_kw_en.json": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;